import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-ink-950 text-white mt-auto">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" aria-hidden />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="flex flex-wrap justify-between gap-12 items-start">
          <div>
            <Link
              to="/"
              className="font-serif text-lg font-semibold text-white tracking-tight hover:text-gold-300 transition-colors"
            >
              Learning Platform
            </Link>
            <p className="text-sm text-slate-400 mt-4 max-w-xs leading-relaxed">
              Professional continuing education at your own pace. Health &amp; Wellness · ABA.
            </p>
          </div>
          <div className="flex gap-8 text-sm tracking-wide">
            <Link
              to="/courses"
              className="text-slate-400 hover:text-gold-300/90 transition-colors"
            >
              Courses
            </Link>
            <Link
              to="/login"
              className="text-slate-400 hover:text-gold-300/90 transition-colors"
            >
              Log in
            </Link>
          </div>
        </div>
        <p className="text-xs text-slate-500 mt-14 tracking-wide">
          © Learning Platform. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
